import React from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS, List} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {Query} from "react-apollo";
import InlineTable from "../../components/InlineTable";
import {GET_ORDER} from "../../queries/shipping";

const FIELDS = fromJS([
  { field: "sku", title: "Product" },
  { field: "title", title: "Title"}
])

function buildPackages(packages) {
  return packages.reduce((acc, pack) => {
    return pack.get("inventory").reduce((acc2, item) => {
      return acc2.push(item);
    }, acc);
  }, List())
}

const ShippingInfoPanel = (props) => {

  let elements = null;
  if (!props.orderId || props.orderId === "") {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let properties = fromJS([
      {prop: "orderId", label: "Id", type: "shippingOrderId"},
      {prop: "autoProcessingStatus", label: "Auto Processing", type: "string"},
      {prop: "driver", label: "Driven By", type: "string"},
      {prop: "originalOrderId", label: "Original Id", type: "shippingOrderId"},
      {prop: "extOrderId", label: "External Id", type: "string"},
      {prop: "externalSource", label: "External Source", type: "string"},
      {prop: "externalSourceOrderId", label: "External Order Id", type: "externalOrderId"},
      {prop: "salesOrderId", label: "Sales Id", type: "salesOrderId"},
      {prop: "refSalesOrderId", label: "Ref Sales Id", type: "salesOrderId"},
      {prop: "accountId", label: "Account Id", type: "accountId"},
      {prop: "type", label: "Type", type: "type"},
      {prop: "notes", label: "Notes", type: "string"},
      {prop: "tags", label: "Tags", type: "tags"},
      {prop: "gift", label: "Sent as gift", type: "boolean"},
      {prop: "jurisdictionId", label: "Shop", type: "string"},
      {prop: "warehouseId", label: "Warehouse", type: "id"},
      {prop: "nrPackages", label: "Packages", type: "integer"},
      {prop: "fulfillmentStatus", label: "Status", type: "fulfillmentStatus"},
      {prop: "inCheckout", label: "In Checkout", type: "boolean"},
      {prop: "courierId", label: "Courier", type: "string"},
      {prop: "courierService", label: "Courier Service", type: "string"},
      {prop: "transportMethod", label: "Transport", type: "string"},
      {prop: "quoteStatus", label: "Quote", type: "string"},
      {prop: "stockStatus", label: "Stock", type: "string"},
      {prop: "scheduled", label: "Scheduled", type: "boolean"},
      {prop: "hold", label: "Hold", type: "boolean"},
      {prop: "prepDate", label: "Prep", type: "utc"},
      {prop: "pickupDate", label: "Pickup", type: "utc"},
      {prop: "deliveryAddress", label: "Address", type: "shippingAddress"},
    ])
    let variables = {orderId: props.orderId}
    elements = (
      <Query query={GET_ORDER} variables={variables} skip={props.orderId === ""} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          let imData = fromJS(data.shippingOrder);
          let items = buildPackages(imData.get("packages"));
          return (
            <React.Fragment>
              <PropertiesList properties={properties} data={imData} />
              <br/>
              <InlineTable
                data={items}
                fields={FIELDS}
                dataType="delivery_product"
                />              
            </React.Fragment>
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title={props.title} expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

ShippingInfoPanel.defaultProps = {
  title: "Order Info"
}

export default ShippingInfoPanel;